import React, { createContext, useState } from "react";
import { IRootState } from "../interfaces/IRootState";
import { IDataContext } from "../interfaces/IDataContext";
import { GetInitialRootState, initialDataContext } from "../helpers/ctxHelper";
import { handleMessage } from "../helpers/stateHelper";

export const DataContext = createContext(initialDataContext);

type DataContextProviderType = {
  children: JSX.Element | JSX.Element[];
};
export const DataContextProvider = ({ children }: DataContextProviderType) => {
  const [state, setRootState] = useState<IRootState>(GetInitialRootState());
  const dataContextValue: IDataContext = {
    state,
    setRootState,
    handleMessage,
  };

  return (
    <DataContext.Provider value={dataContextValue}>
      {children}
    </DataContext.Provider>
  );
};
